import { Component, OnInit, ElementRef  } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { DireccionesService } from "../../services/direcciones.service";
import { ToastrService } from "ngx-toastr";
import { Direccion, Direcciones } from "../../../../../entities/Direcciones";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";

@Component({
  selector: "app-modal-direccion",
  templateUrl: "./modal-direccion.component.html",
  styleUrls: ["./modal-direccion.component.scss"],
})
export class ModalDireccionComponent implements OnInit {
  public direccionesForm: FormGroup;
  public listColonias: Array<string> = [];
  listMensajes: any[];

  constructor(
    private route: Router,
    private fb: FormBuilder,
    private toastService: ToastrService,
    private direccionesService: DireccionesService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private elRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.direccionesForm = this.fb.group({
      id: [],
      estado: [{ value: "", disabled: true }, [Validators.required]],
      municipio: [{ value: "", disabled: true }, [Validators.required]],
      noInterior: [""],
      noExterior: ["", [Validators.required]],
      calle: ["", [Validators.required]],
      calleEsquina: ["", [Validators.required]],
      codigoPostal: ["", [Validators.required]],
      colonia: [{ value: "", disabled: true }, [Validators.required]],
      referencia: ["", [Validators.required]],
      nombreRecibe: ["", [Validators.required]],
      telefono: ["", [Validators.required]],
      esPredeterminada: [true],
    });
  }

  getCP(event: any) {
    const CP = event.target.value;
    this.direccionesForm.patchValue({
      colonia: null,
    });
    if (CP.length === 5) {
      this.direccionesService.getDirectionCp(CP).subscribe((response: any) => {
        if (!response) {
          this.toastService.error("Código postal incorrecto");
          this.direccionesForm.get("colonia").disable();
          this.direccionesForm.patchValue({
            municipio: "",
            estado: "",
            codigoPostal: "",
            colonia: "",
          });
          this.listColonias = [];
          window.scrollTo({
            top: 0,
            behavior: "smooth", // Para un desplazamiento suave
          });
        } else {
          this.listColonias = [];
          this.listColonias = response.codigo_postal.colonias;
          if (this.listColonias.length === 1) {
            this.direccionesForm.patchValue({
              colonia: this.listColonias[0],
            });
          } else {
            this.listColonias = [""];
            response.codigo_postal.colonias.forEach((col) => {
              this.listColonias.push(col);
            });
          }
          this.direccionesForm.get("colonia").enable();
          this.direccionesForm.patchValue({
            municipio: response.codigo_postal.municipio,
            estado: response.codigo_postal.estado,
          });
        }
      });
    }
  }

  agregarDireccion() {
    this.direccionesService
      .agregarDireccion(this.direccionesForm.value)
      .subscribe(
        (response) => {
          this.closeModal(true);
          Swal.fire({
            title: "¡Operación exitosa!",
            text: `¡Se ha agregado de manera exitosa su dirección!`,
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Confirmar",
          });
        },
        (err) => {
          this.direccionesForm.reset();
          Swal.fire({
            title: "¡Ops!",
            text: `¡Error al agregar la dirección!`,
            icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Confirmar",
          });
        }
      );
  }

  submit() {
    this.direccionesForm.get("municipio").enable();
    this.direccionesForm.get("colonia").enable();
    this.direccionesForm.get("estado").enable();

    window.scrollTo({
      top: 0,
      behavior: "smooth", // Para un desplazamiento suave
    });

    if (this.direccionesForm.invalid) {
      this.direccionesForm.get("municipio").disable();
      this.direccionesForm.get("colonia").disable();
      this.direccionesForm.get("estado").disable();
      this.direccionesForm.markAllAsTouched();
      this.toastr.error("Debes completar todos los campos");
    } else {
      this.agregarDireccion();
    }
  }

  soloNumeros(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    this.direccionesForm.patchValue({ telefono: soloNumeros });
  }

  soloLetrasNumerosInt(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloLetrasNumeros = input.value.replace(/[^a-zA-Z0-9\s]/g, "");
    this.direccionesForm.patchValue({ noInterior: soloLetrasNumeros });
  }

  soloLetrasNumerosExt(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloLetrasNumeros = input.value.replace(/[^a-zA-Z0-9]/g, "");
    this.direccionesForm.patchValue({ noExterior: soloLetrasNumeros });
  }

  closeModal(reload: boolean) {
    this.direccionesService.$modal.emit(
      {
        statusModal: false,
        reloadPage: reload
      }
    );
  }
  
}
